import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classNames from "classnames";
import {FormattedMessage, injectIntl} from "react-intl";
import {hashHistory} from "react-router";

import {setActiveQtCategoryIndex} from "./newScopeActions";

import {wizardItemInterface} from "../WizardSetup/WizardItem/wizardItemInterface";

import CheckBox from "../PageLayout/CheckBox";
import WizardItemThumbnail from "../WizardSetup/WizardItem/WizardItemThumbnail";
import {setQuestionPopupState} from "../../actions/A_Popups";
import {
  getWizardList,
  setWizardVisualizer,
  updateWizardList
} from "../WizardSetup/wizardActions";

class NewScopeWizardItem extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isDraggedOver: false
    };
  }

  static propTypes = {
    wizardItem: PropTypes.shape(wizardItemInterface).isRequired,
    qtCategoryIndex: PropTypes.number.isRequired
  };

  setQtCategoryActive = (event) => {
    // console.log(this.props.qtCategory);
    const excludedClassNames = ["ui-svg-checkbox", "ui-icon-remove2", "ui-icon-edit", "ui-input", "ui-button--add2"];
    if (!excludedClassNames.some(className => {
      return event.target.classList.contains(className) || event.target.closest("."+className)
    })) {
      // this.props.setActiveQtCategoryIndex(this.props.qtCategoryIndex);
    }
  };
  //
  // const deleteApply = async () => {
  //   const newWizardList = wizardList
  //     .map(wizardItem => (wizardItem.visualizer === wizardVisualizer) && wizardItem.selected ? null : wizardItem)
  //     .filter(wizardItem => wizardItem);
  //   await saveWizardList(newWizardList);
  //   setWizardList(newWizardList)
  // }
  //
  // deleteQtCategory = () => {
  //   this.props.setQuestionPopupState({
  //     showPopup: true,
  //     questionMessage: this.props.intl.formatMessage({id: "wizard.deleteQuestion"}),
  //     yesClick: deleteApply,
  //     noClick: null
  //   })
  // };

  editQtCategory = async () => {
    this.props.setWizardVisualizer(this.props.wizardItem.visualizer);
    await this.props.getWizardList(this.props.wizardItem.visualizer);
    hashHistory.push(!this.props.wizardItem.enabled ? "/wizard" : "/wizard/" + this.props.wizardItem.id);
  };

  categoryCheckboxClick = () => {
    this.props.wizardItem["enabled"] = !this.props.wizardItem.enabled;
    this.props.updateWizardList(this.props.wizardItem);
  };

  editQtCategoryImage = () => {
    this.props.toggleQtCategoryImagePopup(this.props.qtCategoryIndex)
  };

  onMouseOver = () => {
    // if group is dragged && cat name !== All
    if (window.draggingFeatureGroup && this.props.qtCategoryIndex) {
      this.setState({
        isDraggedOver: true
      })
    }
  };

  onMouseLeave = () => {
    if (this.state.isDraggedOver) {
      this.setState({
        isDraggedOver: false
      })
    }
  };

  render() {
    const {wizardItem, qtCategoryIndex} = this.props;

    return (
      <li data-index={qtCategoryIndex}
          className={classNames(
            'assign-sidebar-list__item',
            'assign-sidebar-list__item--wizard',
            // {'assign-sidebar-list__item--active': qtCategoryIndex === activeQtCategoryIndex},
            // {'assign-sidebar-list__item--isDraggedOver': isDraggedOver},
            // {'assign-sidebar-list__item--draggable': true}
            {'assign-sidebar-list__item--disabled': !wizardItem.enabled}
          )}
          onClick={this.setQtCategoryActive}
          onMouseOver={this.onMouseOver}
          onMouseLeave={this.onMouseLeave}>
        {/*<CheckBox checked={wizardItem.enabled}*/}
        {/*          text={wizardItem.enabled ? 'Enabled' : 'Disabled'}*/}
        {/*          className="assign-sidebar-list__item-checkbox ui-svg-checkbox--secondary"*/}
        {/*          onChecked={this.categoryCheckboxClick}/>*/}
        {/*<button className="ui-icon-remove2 assign-sidebar-list__item-remove" onClick={this.deleteQtCategory}/>*/}
        <span className="secondary assign-sidebar-list__item-visualizer-type">
          <FormattedMessage id={"wizard.subscription." + wizardItem.visualizer}/>
        </span>
        <button className="ui-icon-edit assign-sidebar-list__item-edit" onClick={this.editQtCategory}/>
        <div className="assign-sidebar-list__item-image">
          <WizardItemThumbnail wizardItem={wizardItem} imageOnly={true}/>
        </div>
        <span className="assign-sidebar-list__item-title">{wizardItem.name}</span>
      </li>
    )
  }
}

const mapStateToProps = (store) => {
  const {activeQtCategoryIndex} = store.newScope;
  return {
    activeQtCategoryIndex,
  };
};

const mapDispatchToProps = {
  setActiveQtCategoryIndex,
  setQuestionPopupState,
  updateWizardList,
  setWizardVisualizer,
  getWizardList,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(NewScopeWizardItem)
);
